export default __webpack_public_path__ + "static/media/Sanathan-Polycot.6e76659a.pdf";